import { Product } from "../models"
import { Api } from "@/api"
import { config } from "@/config"
import { Profile } from "@/profile/models"

import Vue from "vue"
import { Component, Prop, Watch } from "vue-property-decorator"
import * as $ from "jquery"

interface ProductOrderCreatePayload {
  name: string
  phone: string
  email: string
  customerNumber?: string
  product: string
}

@Component({ name: "OrderProductModal" })
export default class OrderProductModal extends Vue {
  submitting = false
  submitted = false
  customerNumberVisible = false

  @Prop({ required: true })
  onOrderCreate!: () => void

  @Prop({ required: true })
  onCancelClick!: () => void

  @Prop({ required: true })
  visible!: boolean

  @Prop({ required: true })
  product!: Product

  orderProductPayload: ProductOrderCreatePayload = {
    name: "",
    phone: "",
    email: "",
    customerNumber: "",
    product: this.product._id,
  }

  mounted() {
    const profileData: Profile = JSON.parse(
      window.localStorage.getItem(config.profileStorageKey) || "null",
    )

    if (profileData !== null) {
      this.orderProductPayload.customerNumber = (
        profileData.accountNo || ""
      ).toString()
      this.orderProductPayload.name = (profileData.name || "").toString()
      this.orderProductPayload.email = (profileData.email || "").toString()
      this.orderProductPayload.phone = (profileData.phone || "").toString()

      if (this.orderProductPayload.customerNumber.length > 0) {
        this.customerNumberVisible = true
      }
    }
  }

  @Watch("product")
  onProductChange(value: Product) {
    this.orderProductPayload.product = value._id
  }

  @Watch("visible")
  onVisibleChange(value: boolean) {
    if (value === true) {
      $("#orderProductModal").modal("show")
    } else {
      $("#orderProductModal").modal("hide")
    }
  }

  async onCreate() {
    if (this.submitting === true) {
      return
    }

    this.submitting = true

    const api = Api.createFromEnv()
    const response = await api
      .post("order_requests", this.orderProductPayload)
      .catch(error => {
        console.error(error)
        alert("Das Versenden der Buchungsanfrage ist fehlgeschlagen. ")
      })

    if (response !== undefined) {
      this.submitted = true
    }

    this.submitting = false
  }

  isFormValid() {
    const { orderProductPayload } = this

    return (
      orderProductPayload.name.length > 0 &&
      orderProductPayload.email.length > 0
    )
  }
}
